module.exports = __webpack_public_path__ + "static/media/refresh-icon-inactive.2c255686.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/refresh-icon-inactive.png
// module id = 168
// module chunks = 0